import {createSlice} from "@reduxjs/toolkit";
import {saveProfileSuccess} from "store/reducer/user/profile/reducer";
import {ReducerStatuses} from "services/utils/utils";

export const initialState = {
    index: 0,
    status: ReducerStatuses.IDLE,
    error: ""
}

const slice = createSlice({
    name:"onboarding",
    initialState,
    reducers: {
        onboardingGoBack:(state) => {
            state.index = state.index - 1;
        },
        onboardingCompaniesComplete: (state) => {
            state.index = 2;
        },
        onboardingCompleteStart: (state) => {
            state.status = ReducerStatuses.LOADING;
        },
        onboardingCompleteSuccess: (state) => {
            state.status = ReducerStatuses.SUCCESS;
        },
        onboardingCompleteError: (state, {payload}) => {
            state.status = ReducerStatuses.ERROR;
            state.error = payload;
        },
        onboardingReset: (state) => {
            state.status = ReducerStatuses.IDLE;
            state.index = 0;
        }
    },
    extraReducers: {
        [saveProfileSuccess]: (state) => {
            state.index = 1;
        }
    }
});

const {reducer, actions} = slice;
export const {
    onboardingGoBack, onboardingCompaniesComplete, onboardingCompleteStart, onboardingCompleteError, onboardingCompleteSuccess, onboardingReset
} = actions;
export default reducer;